import { CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  cssVariableStyles,
} from "@newsela/angelou";
import {
  e1Gradient,
  gradientColors,
  gradientBackgrounds,
  gradientWithWhiteBackground,
  partialLinearGradient,
} from "@/components/AIComponents/AiComponents.style";

const { ui } = constants.colors;
const { textSObj, textMObj } = typographyStyles;
const { generateIconColorCss } = cssVariableStyles;
const redIcon = generateIconColorCss({
  primaryColor: constants.colors.ui.red[600],
});

const red = constants.colors.ui.red[600];

export const errorIconCss: CSSObject = {
  marginRight: "5px",
  width: "16px",

  "& *": {
    strokeWidth: "4px",
  },
};
export const errorContainerCss = [
  {
    display: "flex",
    color: red,
    fontSize: "14px",
    svg: {
      width: "16px",
      strokeWidth: "2px",
    },
  },
  redIcon,
];

export const wrapperCss: CSSObject = {
  marginBottom: "1em",
};

export const fieldsetCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "0.5em",
  marginInline: "0",
  padding: 0,
  width: "auto",
  border: "none",
};

export const labelContainerCss: CSSObject = {
  p: {
    ...textMObj,
    margin: 0,
    color: ui.neutral[600],
  },
};

export const legendCss: CSSObject = {
  ...textSObj,
  fontWeight: 700,
  color: ui.neutral[700],
  lineHeight: "114%",

  ":after": {
    content: '"*"',
    color: ui.core[500],
    marginLeft: "0.25rem",
  },
};

export const standardsButtonCss: CSSObject = {
  ...textMObj,
  height: "32px",
  padding: "8px",
  borderRadius: "8px",
  borderColor: "transparent",
  background: gradientWithWhiteBackground,
  backgroundClip: "padding-box, border-box",
  WebkitBackgroundClip: "padding-box, border-box",
  color: gradientColors.position100, // fallback color for icon or non-gradient text
  whiteSpace: "nowrap",

  "&:hover, &:focus-visible": {
    borderColor: "transparent",
    background: e1Gradient,
    backgroundClip: "padding-box, border-box",
    WebkitBackgroundClip: "padding-box, border-box",
  },
};

export const gradientTextCss: CSSObject = {
  background: partialLinearGradient,
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  color: "transparent",
  WebkitTextFillColor: "transparent",
};

export const chipCss: CSSObject = {
  border: "2px solid transparent",
  background: `${gradientBackgrounds[100]} border-box`,
  backgroundClip: "padding-box, border-box",
  maxWidth: "none",
  whiteSpace: "nowrap",
};

export const chipCloseButtonCss: CSSObject = {
  circle: {
    fill: ui.neutral[700],
    stroke: ui.neutral[700],
  },
};

export const chipGroupCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "8px",
  marginTop: "8px",
};
